import {get, post, put, _delete, downloadFile} from './Tools';
import { API_BASE } from '../config';


const getById = async (id) => {
  const response = await get(`${API_BASE}finiquito/${id}`);
  return response;
}

const getAll = async (id) => {
  const response = await get(`${API_BASE}finiquito/baja/${id}`);
  return response;
}

const insert = async (payload) => {
  const response = await post(`${API_BASE}finiquito`, payload);
  return response;
}

const process = async (payload) => {
  const response = await post(`${API_BASE}finiquito/procesar`, payload);
  return response;
}

const generateProporciones = async (payload) => {
  const response = await post(`${API_BASE}finiquito/proporciones`, payload);
  return response;
}

const getProporciones = async (finiquitoId) => {
  const response = await get(`${API_BASE}finiquito/proporciones/${finiquitoId}`);
  return response;
}

const getDetails = async (finiquitoId) => {
  const response = await get(`${API_BASE}finiquito/details/${finiquitoId}`);
  return response;
}

const afectar = async (finiquitoId, status) => {
  const response = await post(`${API_BASE}finiquito/afectar`, {finiquito_id: finiquitoId, estatus: status});
  return response;
}

const desafectar = async (finiquitoId) => {
  const response = await post(`${API_BASE}finiquito/desafectar`, {finiquito_id: finiquitoId});
  return response;
}

const update = async (payload) => {
  const response = await put(`${API_BASE}finiquito`, payload);
  return response;
}

const drop = async (id) => {
  const response = await _delete(`${API_BASE}finiquito/${id}`);
  return response;
}

const print = async (finiquito_id) => {
  const response = await downloadFile(`${API_BASE}finiquito/print/${finiquito_id}`, `${finiquito_id}.pdf`);
  return response;
};



export { process, generateProporciones, getAll, getById, getDetails, getProporciones, afectar, desafectar, insert, update, drop, print };
